<strong [ngStyle]="{'color': color, 'font-size': fontSize}" class="hsr">{{type}}</strong>
